import './menu.css';
export default {
  "breadcrumb": "pf-v5-c-breadcrumb",
  "check": "pf-v5-c-check",
  "dirRtl": "pf-v5-m-dir-rtl",
  "divider": "pf-v5-c-divider",
  "menu": "pf-v5-c-menu",
  "menuBreadcrumb": "pf-v5-c-menu__breadcrumb",
  "menuContent": "pf-v5-c-menu__content",
  "menuFooter": "pf-v5-c-menu__footer",
  "menuGroup": "pf-v5-c-menu__group",
  "menuGroupTitle": "pf-v5-c-menu__group-title",
  "menuHeader": "pf-v5-c-menu__header",
  "menuItem": "pf-v5-c-menu__item",
  "menuItemAction": "pf-v5-c-menu__item-action",
  "menuItemActionIcon": "pf-v5-c-menu__item-action-icon",
  "menuItemCheck": "pf-v5-c-menu__item-check",
  "menuItemDescription": "pf-v5-c-menu__item-description",
  "menuItemExternalIcon": "pf-v5-c-menu__item-external-icon",
  "menuItemIcon": "pf-v5-c-menu__item-icon",
  "menuItemMain": "pf-v5-c-menu__item-main",
  "menuItemSelectIcon": "pf-v5-c-menu__item-select-icon",
  "menuItemText": "pf-v5-c-menu__item-text",
  "menuItemToggleIcon": "pf-v5-c-menu__item-toggle-icon",
  "menuList": "pf-v5-c-menu__list",
  "menuListItem": "pf-v5-c-menu__list-item",
  "menuSearch": "pf-v5-c-menu__search",
  "modifiers": {
    "hidden": "pf-m-hidden",
    "hiddenOnSm": "pf-m-hidden-on-sm",
    "visibleOnSm": "pf-m-visible-on-sm",
    "hiddenOnMd": "pf-m-hidden-on-md",
    "visibleOnMd": "pf-m-visible-on-md",
    "hiddenOnLg": "pf-m-hidden-on-lg",
    "visibleOnLg": "pf-m-visible-on-lg",
    "hiddenOnXl": "pf-m-hidden-on-xl",
    "visibleOnXl": "pf-m-visible-on-xl",
    "hiddenOn_2xl": "pf-m-hidden-on-2xl",
    "visibleOn_2xl": "pf-m-visible-on-2xl",
    "flyout": "pf-m-flyout",
    "top": "pf-m-top",
    "left": "pf-m-left",
    "drilldown": "pf-m-drilldown",
    "drilledIn": "pf-m-drilled-in",
    "currentPath": "pf-m-current-path",
    "static": "pf-m-static",
    "plain": "pf-m-plain",
    "scrollable": "pf-m-scrollable",
    "nav": "pf-m-nav",
    "focus": "pf-m-focus",
    "disabled": "pf-m-disabled",
    "ariaDisabled": "pf-m-aria-disabled",
    "load": "pf-m-load",
    "loading": "pf-m-loading",
    "danger": "pf-m-danger",
    "selected": "pf-m-selected",
    "favorite": "pf-m-favorite",
    "favorited": "pf-m-favorited"
  },
  "themeDark": "pf-v5-theme-dark"
};